import { render, staticRenderFns, recyclableRender, components } from "./community.vue?vue&type=template&id=2c27ccda&scoped=true&"
var renderjs
import script from "./community.vue?vue&type=script&lang=js&"
export * from "./community.vue?vue&type=script&lang=js&"
import style0 from "./community.vue?vue&type=style&index=0&id=2c27ccda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c27ccda",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/community/community.vue"
export default component.exports